import { Animator2DBase } from "./Animator2DBase";
import { AnimatorControllerLayer2D } from "./AnimatorControllerLayer2D";
import { AniParmType } from "./AnimatorControllerParse";
export class Animator2D extends Animator2DBase {
    constructor() {
        super();
        this._controllerLayers = [];
        this._parameters = {};
    }
    get controller() {
        return this._controller;
    }
    set controller(val) {
        if (this._controller)
            this._controller._removeReference();
        this._controller = val;
        if (val) {
            val._addReference();
            val.updateTo(this);
        }
    }
    get parameters() {
        return this._parameters;
    }
    set parameters(val) {
        this._parameters = val;
    }
    _switchState(parentState, currentState) {
        if (parentState) {
            parentState._eventSwitch(currentState);
        }
    }
    _updatePlayer(animatorState, playState, elapsedTime, loop, layerIndex) {
        const isReplay = this._updatePlayerTime(animatorState, playState, elapsedTime, loop);
        this._applyTransition(layerIndex, animatorState._eventtransition(playState._normalizedPlayTime, this.parameters, isReplay));
    }
    _applyTransition(layerindex, transition) {
        if (!transition)
            return false;
        return this.crossFade(transition.destState.name, layerindex, transition.transstartoffset, transition.transduration);
    }
    gotoAndStopByFrame(name, layerIndex, frame) {
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var animatorState = controllerLayer.getStateByName(name);
            if (!animatorState || !animatorState._clip)
                return;
            var allFrame = animatorState._clip._duration * animatorState._clip._frameRate;
            let normalizedTime = frame / allFrame;
            if (1 < normalizedTime)
                normalizedTime = 1;
            this.gotoAndStop(name, layerIndex, normalizedTime);
        }
    }
    getControllerLayer(layerIndex = 0) {
        return this._controllerLayers[layerIndex];
    }
    gotoAndStop(name, layerIndex, normalizedTime) {
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var animatorState = controllerLayer.getStateByName(name);
            if (!animatorState || !animatorState._clip)
                return;
            var playStateInfo = controllerLayer._playStateInfo;
            var curPlayState = playStateInfo._currentState;
            var clipDuration = animatorState._clip._duration;
            var calclipduration = animatorState._clip._duration * (animatorState.clipEnd - animatorState.clipStart);
            this._updateDefVal();
            playStateInfo._resetPlayState(clipDuration * normalizedTime, calclipduration);
            playStateInfo._normalizedPlayTime = normalizedTime;
            controllerLayer._playType = 0;
            if (curPlayState !== animatorState) {
                playStateInfo._currentState = animatorState;
                this._switchState(curPlayState, animatorState);
            }
            animatorState._eventStart(this, layerIndex);
            let addtive = controllerLayer.blendingMode != AnimatorControllerLayer2D.BLENDINGMODE_OVERRIDE;
            this._updateClipDatas(animatorState, addtive, playStateInfo);
            this._setClipDatasToNode(animatorState, addtive, controllerLayer.defaultWeight);
            this.stop();
        }
    }
    play(name, layerIndex = 0, normalizedTime = Number.NEGATIVE_INFINITY) {
        if (this._checkEnterIndex) {
            let i = this._checkEnterIndex.indexOf(layerIndex);
            if (0 <= i) {
                this._checkEnterIndex.splice(i, 1);
            }
        }
        this._isPlaying = true;
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var defaultState = controllerLayer.defaultState;
            if (!name && !defaultState)
                throw new Error("Animator:must have default clip value,please set clip property.");
            var playStateInfo = controllerLayer._playStateInfo;
            var curPlayState = playStateInfo._currentState;
            var animatorState = name ? controllerLayer.getStateByName(name) : defaultState;
            if (!animatorState._clip)
                return;
            var clipDuration = animatorState._clip._duration;
            var calclipduration = animatorState._clip._duration * (animatorState.clipEnd - animatorState.clipStart);
            this._updateDefVal();
            if (curPlayState !== animatorState) {
                if (normalizedTime !== Number.NEGATIVE_INFINITY)
                    playStateInfo._resetPlayState(clipDuration * normalizedTime, calclipduration);
                else
                    playStateInfo._resetPlayState(0.0, calclipduration);
                (curPlayState !== null && curPlayState !== animatorState);
                controllerLayer._playType = 0;
                playStateInfo._currentState = animatorState;
            }
            else {
                if (normalizedTime !== Number.NEGATIVE_INFINITY) {
                    playStateInfo._resetPlayState(clipDuration * normalizedTime, calclipduration);
                    controllerLayer._playType = 0;
                }
                else {
                    playStateInfo._resetPlayState(clipDuration * animatorState.clipStart, calclipduration);
                }
            }
            this._switchState(curPlayState, animatorState);
            animatorState._eventStart(this, layerIndex);
        }
    }
    stop() {
        this._isPlaying = false;
    }
    onUpdate() {
        if (!this._isPlaying)
            return;
        if (this._checkEnterIndex) {
            for (let i = this._checkEnterIndex.length - 1; i >= 0; i--) {
                let index = this._checkEnterIndex[i];
                let enterTransition = this._controllerLayers[index]._enterTransition;
                if (enterTransition.check(0, this.parameters, true)) {
                    var defaultClip = this.getDefaultState(index);
                    this.play(null, index, defaultClip.cycleOffset);
                }
            }
        }
        var delta = this.owner.timer.delta / 1000.0;
        delta = this._applyUpdateMode(delta);
        if (0 == this.speed || 0 == delta) {
            for (var i = 0, n = this._controllerLayers.length; i < n; i++) {
                var controllerLayer = this._controllerLayers[i];
                if (!controllerLayer.enable)
                    continue;
                var playStateInfo = controllerLayer._playStateInfo;
                if (playStateInfo._finish && controllerLayer._playType == 0) {
                    var animatorState = playStateInfo._currentState;
                    this._applyTransition(i, animatorState._eventtransition(playStateInfo._normalizedPlayTime, this.parameters, false));
                }
            }
            return;
        }
        var needRender = true;
        for (var i = 0, n = this._controllerLayers.length; i < n; i++) {
            var controllerLayer = this._controllerLayers[i];
            if (!controllerLayer.enable)
                continue;
            var playStateInfo = controllerLayer._playStateInfo;
            var addtive = controllerLayer.blendingMode != AnimatorControllerLayer2D.BLENDINGMODE_OVERRIDE;
            switch (controllerLayer._playType) {
                case 0:
                    var animatorState = playStateInfo._currentState;
                    var speed = this._speed * animatorState.speed;
                    var finish = playStateInfo._finish;
                    var loop = animatorState.loop;
                    if (-1 >= loop) {
                        var clip = animatorState._clip;
                        if (clip.islooping) {
                            loop = 0;
                        }
                        else {
                            loop = 1;
                        }
                    }
                    let dir = 1;
                    if (!playStateInfo._frontPlay) {
                        dir = -1;
                    }
                    if (finish) {
                        this._applyTransition(i, animatorState._eventtransition(playStateInfo._normalizedPlayTime, this.parameters, false));
                    }
                    else {
                        this._updatePlayer(animatorState, playStateInfo, delta * speed * dir, loop, i);
                    }
                    playStateInfo = controllerLayer._playStateInfo;
                    animatorState = playStateInfo._currentState;
                    if (needRender) {
                        this._updateClipDatas(animatorState, addtive, playStateInfo);
                        if (!finish) {
                            this._setClipDatasToNode(animatorState, addtive, controllerLayer.defaultWeight);
                            this._updateEventScript(animatorState, playStateInfo);
                        }
                    }
                    finish || this._updateStateFinish(animatorState, playStateInfo);
                    break;
            }
        }
    }
    addControllerLayer(controllerLayer) {
        this._controllerLayers.push(controllerLayer);
    }
    crossFade(name, layerIndex = 0, normalizedTime = Number.NEGATIVE_INFINITY, transitionDuration) {
        var controllerLayer = this._controllerLayers[layerIndex];
        if (controllerLayer) {
            var destAnimatorState = controllerLayer.getStateByName(name);
            if (destAnimatorState) {
                this.play(name, layerIndex, normalizedTime);
                return true;
            }
            else {
                console.warn("Invalid layerIndex " + layerIndex + ".");
            }
        }
        return false;
    }
    onAfterDeserialize() {
        let arr = this.controllerLayers;
        if (!arr || null != this.controller)
            return;
        delete this.controllerLayers;
        this._controllerLayers.length = 0;
        for (let layer of arr) {
            this.addControllerLayer(layer);
        }
    }
    onEnable() {
        if (this._checkEnterIndex)
            this._checkEnterIndex.length = 0;
        else
            this._checkEnterIndex = [];
        if (this._isPlaying) {
            for (var i = 0, n = this._controllerLayers.length; i < n; i++) {
                if (this._controllerLayers[i].playOnWake) {
                    var defaultClip = this.getDefaultState(i);
                    if (defaultClip) {
                        let enterTransition = this._controllerLayers[i]._enterTransition;
                        if (enterTransition) {
                            this._isPlaying = true;
                            if (enterTransition.check(0, this.parameters, true)) {
                                this.play(null, i, defaultClip.cycleOffset);
                            }
                            else {
                                this._checkEnterIndex.push(i);
                            }
                        }
                        else {
                            this.play(null, i, defaultClip.cycleOffset);
                        }
                    }
                }
            }
        }
    }
    getDefaultState(layerIndex = 0) {
        var controllerLayer = this._controllerLayers[layerIndex];
        return controllerLayer.defaultState;
    }
    setParamsTrigger(name) {
        const data = this._parameters[name];
        if (data && data.type === AniParmType.Trigger) {
            data.value = true;
        }
        else {
            this._parameters[name] = { name: name, type: AniParmType.Trigger, value: true };
        }
    }
    setParamsNumber(name, value) {
        const data = this._parameters[name];
        if (data && data.type === AniParmType.Float) {
            data.value = value;
        }
        else {
            this._parameters[name] = { name: name, type: AniParmType.Float, value: value };
        }
    }
    setParamsBool(name, value) {
        const data = this._parameters[name];
        if (data && data.type === AniParmType.Bool) {
            data.value = value;
        }
        else {
            this._parameters[name] = { name: name, type: AniParmType.Bool, value: value };
        }
    }
    getParamsvalue(name) {
        let parm = this._parameters[name];
        if (parm) {
            return parm.value;
        }
        return null;
    }
    onDestroy() {
        if (this._controller) {
            this._controller._removeReference();
            this._controller = null;
        }
        for (var i = 0, n = this._controllerLayers.length; i < n; i++)
            this._controllerLayers[i].destroy();
        this._controllerLayers.length = 0;
        this._isPlaying = false;
        this._parameters = null;
    }
}
